import "core-js/modules/es.array.iterator.js";
import React from 'react';
export const useThrottle = (value, limit) => {
  const [throttledValue, setThrottledValue] = React.useState(value);
  const last = React.useRef(Date.now());
  React.useEffect(() => {
    const timerId = setTimeout(function () {
      if (Date.now() - last.current >= limit) {
        setThrottledValue(value);
        last.current = Date.now();
      }
    }, limit - (Date.now() - last.current));
    return () => clearTimeout(timerId);
  }, [value, limit]);
  return throttledValue;
};